import React, { useContext } from "react";
import classes from "./index.module.scss";
import classNames from "classnames";
import Draggable from "react-draggable";
import { useHistory } from "react-router-dom";
import style from "./index.module.scss";
import { CourseContext, resourceModalAtom } from "../../../../Store";
import { courseDetailUrl } from "service/url";
import { useAtomValue } from "jotai";

interface FloatBtnProps {
    isFullscreen: boolean;
    isFolded: boolean;
    toggleFullScreen: () => void;
    toggleFolded: () => void;
}

export default function FloatBtn({
    isFullscreen,
    isFolded,
    toggleFullScreen,
    toggleFolded
}: FloatBtnProps) {
    const history = useHistory();
    const resourceModal = useAtomValue(resourceModalAtom);
    const { course } = useContext(CourseContext);

    function onGoBack() {
        history.replace(courseDetailUrl(course.weekTimeId));
    }

    return (
        <Draggable handle={`.${classes.handle}`}>
            <div
                className={classNames([classes.root])}
                role="button"
                style={{ bottom: 40, left: "calc(50% + 250px)" }}>
                <div className={classes.main}>
                    {!isFullscreen && (
                        <span role="button" onClick={toggleFullScreen}>
                            <img src={require("./img/icon-screen.png")} /> 全屏
                        </span>
                    )}
                    {isFullscreen && (
                        <span role="button" onClick={toggleFullScreen}>
                            <img src={require("./img/icon-screen-out.png")} />{" "}
                            退出全屏
                        </span>
                    )}

                    <span
                        style={{ paddingLeft: 10 }}
                        role="button"
                        onClick={onGoBack}>
                        <img src={require("./img/icon-break.png")} /> 断开投屏
                    </span>

                    {!resourceModal && isFolded && (
                        <span
                            style={{ paddingLeft: 10 }}
                            role="button"
                            onClick={toggleFolded}>
                            <img
                                src={require("./img/icon-fold.png")}
                                className={style.foldImg}
                                style={{
                                    transform: `rotate(${
                                        isFolded ? 0 : 180
                                    }deg)`
                                }}
                                alt=""
                            />{" "}
                            展开
                        </span>
                    )}
                </div>

                <div className={classes.handle} />
            </div>
        </Draggable>
    );
}
